module.exports = __webpack_public_path__ + "static/media/beep-07.d932c606.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/static/Sound/beep-07.mp3
// module id = 734
// module chunks = 0